import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";

function SSL() {

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, []);

  return (
    <div className="page container">

       <Helmet>
        <title>SSL Certified | realgeneric shop</title>
        <meta
          name="description"
          content="Realgenericshop is SSL certified, ensuring encrypted and secure transactions for all your online purchases."
        />
        <link rel="canonical" href="https://realgenericshop.com/ssl" />
      </Helmet>

      <h1>SSL Certified – Safe & Encrypted Online Transactions</h1>

      <p>
        <b>Realgenericshop</b> is SSL certified, which means all browsing and transactions
        are protected using Secure Socket Layer (SSL) encryption. This ensures that all
        data shared between you and our website remains private and secure.
      </p>

      <h3>Why Realgenericshop Uses SSL?</h3>

      <p>
        Along with offering affordable branded and generic medicines, our SSL certification ensures:
      </p>

      <ul>
        <li>Protection of your payment and personal data</li>
        <li>Prevention of identity theft and cyber threats</li>
        <li>Secure checkout for every order</li>
        <li>Trusted and reliable online shopping experience</li>
      </ul>

      <h3>How SSL Protects You</h3>

      <p>
        When you see the padlock symbol in your browser and “https://” in the URL,
        it means your connection is SSL-protected. This prevents hackers from accessing
        sensitive information such as card details, addresses, or health data during checkout.
      </p>

      <p>
        SSL encryption protects not only payments but also login details, prescription uploads,
        and all personal interactions on the website.
      </p>

      <h3>Customer Privacy Guaranteed</h3>

      <p>
        With layered protection from SSL encryption along with AWS and security systems,
        <b>Realgenericshop</b> ensures complete protection of your health and personal data.
      </p>

      <h3>FAQs</h3>

      <h4>What does SSL certified mean?</h4>
      <p>
        SSL certification means all communication between your browser and our website
        is encrypted to prevent unauthorized access or data theft.
      </p>

      <h4>How can I check SSL security?</h4>
      <p>
        You can verify SSL by checking the padlock icon in the browser and ensuring
        the website starts with “https://realgenericshop.com”.
      </p>

      <h4>Does SSL protect only payments?</h4>
      <p>
        No. SSL protects all data including login credentials, personal details,
        prescriptions, and payment information.
      </p>

      <h4>Why is SSL important for online pharmacies?</h4>
      <p>
        SSL ensures complete confidentiality and trust, which is essential when handling
        sensitive medical and financial data online.
      </p>

    </div>
  );
}

export default SSL;